import React, { Component } from 'react';
import {Grid, Typography, Button, Slider, Card, Paper, TextField} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
import Logo from '../assets/360_logo.png';
import StepChange from '../assets/step_change.png';
import HighPerformance from '../assets/high_performance.png';
import Ownership from '../assets/ownership.png';
import CustomerLedEfficiency from '../assets/customer_led_efficiency.png';
import Professionalism from '../assets/professionalism.png';
import Collaboration from '../assets/collaboration.png';
import { ArrowForwardIosRounded, Settings } from '@material-ui/icons';
import DatasheetView from './DatasheetView';
import moment from 'moment';

export default class AssessmentForm360 extends Component {

    constructor(props) {
        super(props);
        
        this.initital_state = {  
            q1_score: null,
            q2_score: null,
            q3_score: null,
            q4_score: null,
            q5_score: null,
            q6_score: null,
            comment: "",
            has_comment: false,
            writing: false,
            partially_complete: false,
            error: false,
            error_message: '',
            primary_button_enabled: false,
            primary_button_text: 'Submit Assessment',
            selecting_assessor: false,
            show_assessors: false,
            search_name:'',
            search_number: '',
            search_ready:false,
            searching:false,
            assessors_array: [],
            assessor_name: this.props.employee_name,
            assessor_number: this.props.employee_number
        };
        this.state = {  
            q1_score: null,
            q2_score: null,
            q3_score: null,
            q4_score: null,
            q5_score: null,
            q6_score: null,
            comment: "",
            has_comment: false,
            writing: false,
            partially_complete: false,
            error: false,
            error_message: '',
            primary_button_enabled: false,
            primary_button_text: 'Submit Assessment',
            is_super_admin_override: false,
            selecting_assessor: false,
            show_assessors: false,
            search_name:'',
            search_number: '',
            search_ready:false,
            searching:false,
            assessors_array: [],
            assessor_name: this.props.employee_name,
            assessor_number: this.props.employee_number
        };

        this.pattern = new RegExp("^[a-zA-Z0-9 `'?,.;!]+$");
        this.datasheetFieldSpecs = [
            { field: 'select', headerName: ' ', width: 120, headerAlign: 'center', align:'center',
            sortable: false,
            renderCell: (parms) => (
                <Button 
                    onClick={()=>this.updateAssessor(parms)} 
                    color='primary'
                    variant='outlined'
                    disabled={!this.state.search_ready}
                >
                    Select
                    {/* <HowToRegTwoTone/> */}
                </Button>
            )},
            { field: 'name', headerName: 'Employee', width: 180},
            { field: 'job_title', headerName: 'Job Title', width: 160},
            { field: 'store_code', headerName: 'Store Code', width: 120, sortable:false},
            { field: 'store', headerName: 'Store', width: 160},
            { field: 'region', headerName: 'Region', width: 160},
            { field: 'date_of_entry', headerName: 'DOE', width: 120},
            { field: 'reports_to_rom', headerName: 'Manager Code', align: 'center',width: 125}
        ]
    }

    componentDidMount = () => {
        //   check whether this is a capture of someone else's assessment by a super_admin
      if ((this.props.assessment.assessment_type_id==="M"&&(this.props.assessment.reports_to_rom!==this.props.rom_code))||(this.props.assessment.requires_nomination&&(this.props.assessment.nominated_assessor_id!==this.props.employee_number))) {
        this.setState({is_super_admin_override:true})
      }
    };    

    handleSlide1Change = (e,newVal) => {
        // console.log('newVal :>> ', newVal);
        // console.log('e.id :>> ', e.target.id);
        this.setState({q1_score:newVal,partially_complete:true});
    }

    handleSlide2Change = (e,newVal) => {
        // console.log('newVal :>> ', newVal);
        // console.log('e.id :>> ', e.target.id);
        this.setState({q2_score:newVal,partially_complete:true});
    }

    handleSlide3Change = (e,newVal) => {
        // console.log('newVal :>> ', newVal);
        // console.log('e.id :>> ', e.target.id);
        this.setState({q3_score:newVal,partially_complete:true});
    }

    handleSlide4Change = (e,newVal) => {
        // console.log('newVal :>> ', newVal);
        // console.log('e.id :>> ', e.target.id);
        this.setState({q4_score:newVal,partially_complete:true});
    }

    handleSlide5Change = (e,newVal) => {
        // console.log('newVal :>> ', newVal);
        // console.log('e.id :>> ', e.target.id);
        this.setState({q5_score:newVal,partially_complete:true});
    }

    handleSlide6Change = (e,newVal) => {
        // console.log('newVal :>> ', newVal);
        // console.log('e.id :>> ', e.target.id);
        this.setState({q6_score:newVal,partially_complete:true});
    }

    handleCommentChange = (e) => {
        // console.log('e.target.value :>> ', e.target.value);
        if (!e.target.value){
            this.setState({comment:"", has_comment:false});
        } else if (this.pattern.test(e.target.value)&&(e.target.value.length<=500)){
            if (e.target.value.length>=1){
                this.setState({comment:e.target.value, partially_complete:true,has_comment:true});
            } else {
                this.setState({comment:e.target.value, partially_complete:true,has_comment:false});
            }
        }
    }
   
    resetMe = () => {
        this.setState(this.initital_state);
        // this.componentDidMount();
    }

    changeAssessor = () => {
        if (this.props.super_admin){
            this.setState({selecting_assessor:true})
        }
    }

    updateAssessor = (parms) => {
        // console.log('parms.row :>> ', parms.row);
        if (this.props.super_admin){
            this.setState({selecting_assessor:false,search_name:'',search_ready:false,searching:false,error:false,error_message:'',show_assessors:false, assessor_name: parms.row.name, assessor_number:parms.row.id})
        }
    }

    runSearch = (e) => {
        e.preventDefault();
        // console.log('e :>> ', e);

        if (!this.state.search_name&&!this.state.search_number){return}

        this.setState({searching:true, search_ready:false});
        Gserv.sendCommand('find_users_for_group_registry',this.props.gwt,{
            search_string: this.state.search_name? this.state.search_name : this.state.search_number,
            search_type: this.state.search_name? 'surname' : 'employee number',
            assessment: this.state.current_record
        })
        .then(reply => {
            // console.log('search reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (find_users_for_group_registry) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (find_users_for_group_registry) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"){
                //not broken, but for some reason couldn't update / add record
                if (reply.statusCode===204){
                    this.setState({error_message:"No employee records found matching the search."});
                } else {
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."})
                }
            } else {
                if (reply.Records){
                    let record_array = reply.Records;
                    let DOE = null;
                    for (var i=0;i<record_array.length;i++){
                        DOE = new moment(record_array[i].date_of_entry).format("YYYY-MM-DD");
                        record_array[i].date_of_entry = DOE;
                    }
                }
                this.setState({assessors_array:reply.Records,show_assessors:true,searching:false,search_ready:true});

            }
        });

    }

    submitMe = () => {
        this.setState({writing:true});
        const payload = {
            q1_score : this.state.q1_score,
            q2_score : this.state.q2_score,
            q3_score : this.state.q3_score,
            q4_score : this.state.q4_score,
            q5_score : this.state.q5_score,
            q6_score : this.state.q6_score,
            comment : this.state.comment,
            assessment : this.props.assessment,
            assessor_employee_number : this.state.assessor_number,
            assessor_not_submitter : this.state.assessor_number !== this.props.employee_number ? true : false
        }
        Gserv.sendCommand('create_360_assessment',this.props.gwt,payload)
        .then(reply=>{
            if (reply.error){
                console.log('error on return from Gserv (create_assessment) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",writing:false});
            } else if (reply.Result!=="Success"){
                console.log('error on return from Gserv (create_assessment) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",writing:false});
            } else {
                this.props.resetParentState();             
            }
        });
    }

    render() {
        const assmt = this.props.assessment;
        return (
            <div>

                {!this.state.writing&&    
                <Paper
                    elevation={3}
                >
                <Grid
                    container
                    direction='column'
                    // justifyContent='center'
                    // alignContent='center'
                    style={{padding:'25px'}}
                >
                    <Typography
                        style={{paddingTop:15, textAlign:'left'}}
                    >
                        <img
                            src={Logo}
                            alt={'360 Logo'}
                            height={78}
                            width={161}
                        />
                        <br/>
                        <b>Leadership Behaviour Assessment</b>
                    </Typography>

                    <Typography
                        style={{borderWidth:'1px',borderStyle:'solid',padding:'10px'}}
                    >
                        {assmt.assessment_type} assessment for {assmt.assessee_name} ({assmt.job_title}) for cycle {assmt.cycle_code}
                     </Typography>

                    <br/>

                    <Typography
                        color='primary'
                    >
                        <b><i>To what extent {assmt.assessment_type_id==="S"? "do you" : "does " + assmt.assessee_name} reflect, through {assmt.assessment_type_id==="S"? "your" : "his or her"} actions, the following leadership behaviors? </i></b><br/>(1 – Not at all, 10 – Excellently)
                    </Typography>

                    {/* <br/> */}   
                    <hr style={{width:'100%'}}/>        

                    <Grid
                        container
                        direction='row'
                        alignContent='center'
                        justifyContent='flex-start'
                        style={{width:'1050px'}}
                    >
                        <img
                            src={StepChange}
                            alt={'Step Change'}
                            height={110}
                            style={{alignSelf:'center'}}
                            // width={334}
                        />
                        &nbsp;&nbsp;
                        <Card
                            elevation={2}
                        >
                            <ul style={{textAlign:'left',marginRight:'10px',width:'320px'}}>
                                <Typography style={{textAlign:'left'}}>
                                    <li>Challenge the Status Quo</li>
                                    <li>Strive for continuous improvement</li>
                                    <li>Commit to remaining relevant</li>
                                    <li>Be open to change and improvement</li>
                                    <li>Solve the root cause of the problem</li>
                                    <li>Act with urgency and be <b>bold</b></li>
                                </Typography>
                            </ul>
                        </Card>
                        <ArrowForwardIosRounded
                            fontSize='large'
                            style={{alignSelf:'center'}}
                        />
                        &nbsp;&nbsp;
                        <Slider
                            aria-label='Step Change'
                            // defaultValue={0}
                            step={1}
                            marks
                            min={1}
                            max={10}
                            id='Q1'
                            valueLabelDisplay="auto"
                            style={{width:'35%',alignSelf:'center'}}
                            value={this.state.q1_score}
                            onChange={this.handleSlide1Change}
                        />
                        &nbsp;&nbsp;
                        {!this.state.q1_score&&
                        <Typography
                            color='secondary'
                            style={{alignSelf:'center'}}
                        >
                            <i>slide*</i>
                        </Typography>}
                        {this.state.q1_score&&
                        <Typography
                            color="primary"
                            style={{alignSelf:'center',fontSize:40}}
                        >
                            <b>{this.state.q1_score}</b>
                        </Typography>}
                    </Grid>
                    <hr style={{width:'100%'}}/>        
                    <Grid
                        container
                        direction='row'
                        alignContent='center'
                        justifyContent='flex-start'
                        style={{width:'1050px'}}
                    >
                        <img
                            src={HighPerformance}
                            alt={'High Performance'}
                            height={110}
                            // width={334}
                            style={{alignSelf:'center'}}
                        />
                        &nbsp;&nbsp;
                        <Card
                            elevation={2}
                        >
                            <ul style={{textAlign:'left',marginRight:'10px',width:'320px'}}>
                            <Typography style={{textAlign:'left'}}>
                                <li>Focused on the end goal</li>
                                <li>Become good at closing work out (follow through to completion)</li>
                                <li>Be exceptional in our execution</li>
                                <li>Drive results</li>
                            </Typography>
                            </ul>
                        </Card>
                        <ArrowForwardIosRounded
                            fontSize='large'
                            style={{alignSelf:'center'}}
                        />
                        &nbsp;&nbsp;
                        <Slider
                            aria-label='High Performance'
                            // defaultValue={0}
                            step={1}
                            marks
                            min={1}
                            max={10}
                            id='Q2'
                            valueLabelDisplay="auto"
                            style={{width:'35%',alignSelf:'center'}}
                            value={this.state.q2_score}
                            onChange={this.handleSlide2Change}
                        />
                        &nbsp;&nbsp;
                        {!this.state.q2_score&&
                        <Typography
                            color='secondary'
                            style={{alignSelf:'center'}}
                        >
                            <i>slide*</i>
                        </Typography>}
                        {this.state.q2_score&&
                        <Typography
                            color="primary"
                            style={{alignSelf:'center',fontSize:40}}
                        >
                            <b>{this.state.q2_score}</b>
                        </Typography>}

                    </Grid>
                    <hr style={{width:'100%'}}/>        
                    <Grid
                        container
                        direction='row'
                        alignContent='center'
                        justifyContent='flex-start'
                        style={{width:'1050px'}}
                    >
                        <img
                            src={Ownership}
                            alt={'Ownership'}
                            height={110}
                            // width={334}
                            style={{alignSelf:'center'}}
                        />
                        &nbsp;&nbsp;
                        <Card
                            elevation={2}
                        >
                            <ul style={{textAlign:'left',marginRight:'10px',width:'320px'}}>
                            <Typography style={{textAlign:'left'}}>
                                <li>Own our decisions, actions and results</li>
                                <li>Admit mistakes and highlight problems as they arise</li>
                                <li>Own the problem, own the solution and learn from our mistakes</li>
                                <li>Do what we say!</li>
                            </Typography>
                            </ul>
                        </Card>
                        <ArrowForwardIosRounded
                            fontSize='large'
                            style={{alignSelf:'center'}}
                        />
                        &nbsp;&nbsp;
                        <Slider
                            aria-label='Ownership'
                            // defaultValue={0}
                            step={1}
                            marks
                            min={1}
                            max={10}
                            id='Q3'
                            valueLabelDisplay="auto"
                            style={{width:'35%',alignSelf:'center'}}
                            value={this.state.q3_score}
                            onChange={this.handleSlide3Change}
                        />
                        &nbsp;&nbsp;
                        {!this.state.q3_score&&
                        <Typography
                            color='secondary'
                            style={{alignSelf:'center'}}
                        >
                            <i>slide*</i>
                        </Typography>}
                        {this.state.q3_score&&
                        <Typography
                            color="primary"
                            style={{alignSelf:'center',fontSize:40}}
                        >
                            <b>{this.state.q3_score}</b>
                        </Typography>}
                    </Grid>
                    <hr style={{width:'100%'}}/>        

                    <Grid
                        container
                        direction='row'
                        alignContent='center'
                        justifyContent='flex-start'
                        style={{width:'1050px'}}
                    >
                        <img
                            src={CustomerLedEfficiency}
                            alt={'CustomerLedEfficiency'}
                            height={110}
                            // width={334}
                            style={{alignSelf:'center'}}
                        />
                        &nbsp;&nbsp;
                        <Card
                            elevation={2}
                        >
                            <ul style={{textAlign:'left',marginRight:'10px',width:'320px'}}>
                            <Typography style={{textAlign:'left'}}>
                                <li>Understand the  (internal/external ) customer’s needs</li>
                                <li>Deliver cost-effective customer service</li>
                                <li>Build relationships with our customers (Internal/External)</li>
                                <li>Honour our commitments in line with the AutoZone value proposition</li>
                                <li>Think, plan and act with customer needs in mind</li>
                            </Typography>
                            </ul>
                        </Card>
                        <ArrowForwardIosRounded
                            fontSize='large'
                            style={{alignSelf:'center'}}
                        />                   
                        &nbsp;&nbsp;
                        <Slider
                            aria-label='CustomerLedEfficiency'
                            // defaultValue={0}
                            step={1}
                            marks
                            min={1}
                            max={10}
                            id='Q4'
                            valueLabelDisplay="auto"
                            style={{width:'35%',alignSelf:'center'}}
                            value={this.state.q4_score}
                            onChange={this.handleSlide4Change}
                        />
                        &nbsp;&nbsp;
                        {!this.state.q4_score&&
                        <Typography
                            color='secondary'
                            style={{alignSelf:'center'}}
                        >
                            <i>slide*</i>
                        </Typography>}
                        {this.state.q4_score&&
                        <Typography
                            color="primary"
                            style={{alignSelf:'center',fontSize:40}}
                        >
                            <b>{this.state.q4_score}</b>
                        </Typography>}
                    </Grid>
                    <hr style={{width:'100%'}}/>        

                    <Grid
                        container
                        direction='row'
                        alignContent='center'
                        justifyContent='flex-start'
                        style={{width:'1050px'}}
                    >
                        <img
                            src={Professionalism}
                            alt={'Professionalism'}
                            height={110}
                            // width={334}
                            style={{alignSelf:'center'}}
                        />
                        &nbsp;&nbsp;
                        <Card
                            elevation={2}
                        >
                            <ul style={{textAlign:'left',marginRight:'10px',width:'320px'}}>
                            <Typography style={{textAlign:'left'}}>
                                <li>Be experts in our roles</li>
                                <li>Treat each other with respect and trust</li>
                                <li>Always assume best intentions (think the best of each other)</li>
                                <li>Enable the team to act and execute with confidence</li>
                                <li>Enable him/herself to act and execute with confidence</li>
                                <li>Be inclusive, consistent and fair</li>
                            </Typography>
                            </ul>
                        </Card>
                        <ArrowForwardIosRounded
                            fontSize='large'
                            style={{alignSelf:'center'}}
                        />                   
                        &nbsp;&nbsp;
                        <Slider
                            aria-label='Professionalism'
                            // defaultValue={0}
                            step={1}
                            marks
                            min={1}
                            max={10}
                            id='Q5'
                            valueLabelDisplay="auto"
                            style={{width:'35%',alignSelf:'center'}}
                            value={this.state.q5_score}
                            onChange={this.handleSlide5Change}
                        />
                        &nbsp;&nbsp;
                        {!this.state.q5_score&&
                        <Typography
                            color='secondary'
                            style={{alignSelf:'center'}}
                        >
                            <i>slide*</i>
                        </Typography>}
                        {this.state.q5_score&&
                        <Typography
                            color="primary"
                            style={{alignSelf:'center',fontSize:40}}
                        >
                            <b>{this.state.q5_score}</b>
                        </Typography>}
                    </Grid>
                    <hr style={{width:'100%'}}/>        

                    <Grid
                        container
                        direction='row'
                        alignContent='center'
                        justifyContent='flex-start'
                        style={{width:'1050px'}}
                    >
                        <img
                            src={Collaboration}
                            alt={'Collaboration'}
                            height={110}
                            // width={334}
                            style={{alignSelf:'center'}}
                        />
                        &nbsp;&nbsp;
                        <Card
                            elevation={2}
                        >
                            <ul style={{textAlign:'left',marginRight:'10px',width:'320px'}}>
                            <Typography style={{textAlign:'left'}}>
                                <li>Work as One AutoZone</li>
                                <li>Listen to each other’s ideas</li>
                                <li>Actively work to break down silos</li>
                                <li>Build on Ideas, don’t break them down</li>
                                <li>Enhance Communication</li>
                            </Typography>
                            </ul>
                        </Card>
                        <ArrowForwardIosRounded
                            fontSize='large'
                            style={{alignSelf:'center'}}
                        />                   
                        &nbsp;&nbsp;
                        <Slider
                            aria-label='Collaboration'
                            // defaultValue={0}
                            step={1}
                            marks
                            min={1}
                            max={10}
                            id='Q6'
                            valueLabelDisplay="auto"
                            style={{width:'35%',alignSelf:'center'}}
                            value={this.state.q6_score}
                            onChange={this.handleSlide6Change}
                        />
                        &nbsp;&nbsp;
                        {!this.state.q6_score&&
                        <Typography
                            color='secondary'
                            style={{alignSelf:'center'}}
                        >
                            <i>slide*</i>
                        </Typography>}
                        {this.state.q6_score&&
                        <Typography
                            color="primary"
                            style={{alignSelf:'center',fontSize:40}}
                        >
                            <b>{this.state.q6_score}</b>
                        </Typography>}
                    </Grid>
                    <hr style={{width:'100%'}}/>        

                    <TextField 
                        id={'comment'}
                        type={'text'}
                        fullWidth={true}
                        label={'Comment'}
                        inputProps={{maxLength:500,minLength:10}}
                        autoCapitalize='off'
                        autoComplete='off'
                        autoCorrect='off'
                        required={true}
                        onChange={this.handleCommentChange}
                        value={this.state.comment}
                        disabled={this.writing}
                        variant='standard'
                    />

                    <Grid 
                        container
                        direction='row'
                        style={{marginTop:'15px'}}
                        // justifyContent='center'
                        alignItems='center'
                        
                    >            
                        <Typography style={{textAlign:'left'}}>
                            Assessor: <b>{this.state.assessor_name}</b> [{this.state.assessor_number}] 
                        </Typography>
                        {this.state.is_super_admin_override&&
                            <Button 
                                variant="contained"
                                color='primary'
                                style={{marginLeft:'10px'}}
                                onClick={this.changeAssessor}
                                disabled={this.state.selecting_assessor}
                            >
                                Change
                        </Button>}
                    </Grid>

                    {/* ** Start - Assessor Selection Panel ** */}
                    {this.state.selecting_assessor&&
                    <div>    
                        <hr/>    
                        <Typography
                            color='primary'
                            style={{paddingTop:10}}
                        >
                            Select Assessor
                        </Typography>
                        <Grid
                            container
                            direction='column'
                            justifyContent='space-evenly'
                            alignContent='center'
                            style={{padding:15}}
                        >
    
                            <form onSubmit={this.runSearch}>
                                <TextField
                                    autoComplete="off"
                                    autoCorrect="off"
                                    autoCapitalize="on"
                                    autoFocus={true}
                                    label={'Surname Search'}
                                    variant='outlined'
                                    value={this.state.search_name}
                                    onChange={(e) => {
                                        const outText = e.target.value.replace(/[^ A-Za-z]+/g, '').toUpperCase();
                                        const can_sub = (outText.length>2);
                                        this.setState({search_name: outText, search_number: '', search_ready: can_sub, error: false});
                                    }}
                                    // required
                                    style={{marginBottom:'10px', marginRight:'10px'}}
                                    disabled={this.state.searching}
                                />
                                <TextField
                                    autoComplete="off"
                                    autoCorrect="off"
                                    autoCapitalize="off"
                                    autoFocus={false}
                                    label={'Employee # Search'}
                                    variant='outlined'
                                    value={this.state.search_number}
                                    onChange={(e) => {
                                        const outText = e.target.value.replace(/[^ A-Za-z0-9]+/g, '').toUpperCase();
                                        const can_sub = (outText.length>2);
                                        this.setState({search_number: outText, search_name:"", search_ready: can_sub, error: false});
                                    }}
                                    // required
                                    style={{marginBottom:'10px', marginLeft:'10px'}}
                                    disabled={this.state.searching}
                                />
                                <br/>
                                <Button
                                    variant='contained'
                                    color='primary'
                                    type='submit'
                                    disabled={!this.state.search_ready}
                                >
                                    Search
                                </Button>
                                <Button
                                    variant='contained'
                                    onClick={()=>this.setState({selecting_assessor:false,search_name:'',search_ready:false,searching:false,error:false,error_message:'',show_assessors:false, assessor_name: this.props.employee_name, assessor_number:this.props.employee_number})}
                                    style={{marginLeft:'10px'}}
                                    // color='primary'
                                    // type='submit'
                                >
                                    I'm the Assessor
                                </Button>
                                <Button
                                    variant='contained'
                                    onClick={()=>this.setState({selecting_assessor:false,search_name:'',search_number:'',search_ready:false,searching:false,error:false,error_message:'',show_assessors:false})}
                                    style={{marginLeft:'10px'}}
                                    // color='primary'
                                    // type='submit'
                                >
                                    Back
                                </Button>
                            </form>
                        </Grid>
                    </div>}
    
                    {this.state.show_assessors&&
                    <DatasheetView
                        dataset={this.state.assessors_array}
                        fieldspecs={this.datasheetFieldSpecs}
                        delete={false}
                        edit={false}
                        handleDelete={null}
                        handleEdit={null}
                        loading={this.state.searching}
                        deleteHeaderName={'Delete'}
                        height={350}
                    />}
                    {/* **End Assessor Selection Panel */}

                    <Grid item>
                        <Typography color='secondary' style={{Width:1200,maxWidth:1200, textAlign:'center'}}>{this.state.error_message}</Typography>
                        {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
                    </Grid>

                    <Grid
                        container
                        direction='row'
                        alignContent='center'
                        justifyContent='center'
                        style={{width:'1050px'}}
                    >
                        <Button 
                            type='button'
                            variant='outlined'
                            disabled={this.state.writing}
                            onClick={this.props.returnToParent}
                            style={{marginTop:'20px',marginBottom:'10px'}}
                        >
                            Cancel
                        </Button>
                        <Button 
                            type='button'
                            variant='outlined'
                            disabled={!this.state.partially_complete}
                            onClick={this.resetMe}
                            style={{marginTop:'20px',marginBottom:'10px'}}
                        >
                            Reset
                        </Button>
                        <Button 
                            color='primary'
                            variant='contained'
                            disabled={!(this.state.q1_score&&this.state.q2_score&&this.state.q3_score&&this.state.q4_score&&this.state.q5_score&&this.state.q6_score&&this.state.has_comment)||this.state.writing}
                            style={{marginTop:'20px',marginBottom:'10px'}}
                            onClick={this.submitMe}
                        >
                            {this.state.primary_button_text}
                        </Button>
                    </Grid>
                </Grid>
                </Paper>}

                {this.state.writing&&            
                <div className='pageContainer' style={{minHeight:'70vh'}}>
                <div>
                    <Settings className='icn-spinner' /> Submitting...
                </div>
                </div>}

                <br/><br/>
            </div>
        );
    }
    
}